import canUseDOM from '../canUseDOM/dac5c056569482021accf87fd538ecc27d8fd0c72464de839f0931e17633376c.cfe-internal.js';

var KEYBOARD_USER_CLASS = 'keyboard-user';
function getIsKeyboardUser() {
  return canUseDOM() && document.body.classList.contains(KEYBOARD_USER_CLASS);
}
function setIsKeyboardUser(newIsKeyboardUser) {
  if (!canUseDOM()) {
    return;
  }

  if (newIsKeyboardUser) {
    document.body.classList.add(KEYBOARD_USER_CLASS);
  } else {
    document.body.classList.remove(KEYBOARD_USER_CLASS);
  }
}
function enableKeyboardUserClass() {
  if (canUseDOM() && !window.keyboardUserListenersAdded) {
    window.keyboardUserListenersAdded = true;
    document.addEventListener('mousedown', function () {
      return setIsKeyboardUser(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.keyCode === 9) {
        setIsKeyboardUser(true);
      }
    });
  }
}

export { enableKeyboardUserClass, getIsKeyboardUser, setIsKeyboardUser };
